import { css } from '@emotion/react'
import { memo, RefObject, SyntheticEvent } from 'react'
import Button from '../Buttons/Button'
import Filter from '../Icons/Filter'
import { getThemeSpacing } from '../styles/appTheme'
import { palette } from '../styles/colors'

const filterStyles = css({
    minWidth: 32,
    fontSize: 8,
    padding: getThemeSpacing(0.5),
    '& svg': {
        color: palette.contrastIcons,
    },
})

interface IButtonFilter {
    disabled?: boolean
    styleOverrides?: any
    size?: number
    isActive?: boolean
    ref?: RefObject<HTMLElement>
    showLabel?: boolean
    title?: string
    onClick?(event: SyntheticEvent, isActive?: boolean): void
}

const ButtonFilter = ({
    disabled = false,
    isActive = false,
    ref,
    showLabel = false,
    size,
    styleOverrides,
    title = null,
    onClick = () => {},
}: IButtonFilter) => {
    const label = showLabel ? <span>{title ?? 'Filter'}</span> : null

    const handleOnClick = (event: SyntheticEvent) => {
        onClick?.(event, !isActive)
    }

    return (
        <Button
            css={[filterStyles, styleOverrides]}
            onClick={handleOnClick}
            disabled={disabled}
            clean
            {...(ref && { ref })}
        >
            <Filter size={size} />
            {label}
        </Button>
    )
}

export default memo(ButtonFilter)
